import {
  GeckoAssetModel,
  GeckoComponentDataFrame,
  GeckoComponentModel,
} from 'types'

import { AllSceneFactoryProps, SceneFactoryConfig } from './sceneFactory'

interface SceneDispatchProps {
  showMultiComponentView: boolean
  showAxesHelper: boolean
  assetModel: GeckoAssetModel | undefined
  componentModel: GeckoComponentModel | undefined
  focusedCDF: GeckoComponentDataFrame | undefined
}

export const sceneDispatch = (
  sceneFactoryConfigs: SceneFactoryConfig[],
  {
    showMultiComponentView,
    showAxesHelper,
    assetModel,
    componentModel,
    focusedCDF,
  }: SceneDispatchProps
) => {
  const sceneFactoryProps: AllSceneFactoryProps = {
    assetModel,
    componentModel,
    cdf: focusedCDF,
    showAxesHelper,
  }

  for (const config of sceneFactoryConfigs) {
    if (
      showMultiComponentView !== !!config.multiComponentView ||
      (config.assetModels &&
        (!assetModel || !config.assetModels.includes(assetModel.data.type))) ||
      (config.componentModels &&
        (!componentModel ||
          !config.componentModels.includes(componentModel.type))) ||
      (config.otherChecks && !config.otherChecks(sceneFactoryProps))
    )
      continue

    if (config.sceneFunc && !!assetModel && !!componentModel) {
      return config.sceneFunc({
        assetModel: assetModel,
        componentModel: componentModel,
      })
    }

    if (config.cdfSceneFunc) return config.cdfSceneFunc(sceneFactoryProps)
  }
  return null
}
